// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__pFx4z","selects":"Documents_selects__3gUQD"};